import React from 'react';
import { Modal, Header, ModalProps, SemanticICONS, StrictHeaderProps } from 'semantic-ui-react';
import UiButton from '../uiButton';
import { colorsModeUI, MODE_UI_OPTIONS } from '../modeUI';
import { createUseStyles } from 'react-jss';
import './index.css';

type UiModalProps = {
  header?: {
    icon?: StrictHeaderProps['icon'];
    content?: string;
  };
  content?: string;
  // FIXME: not typed right, derivate from uiButton
  buttons?: {
    key?: string;
    negative?: boolean;
    primary?: boolean;
    onClick?(...args: unknown[]): unknown;
    label?: string;
    iconName?: string;
    showLabels?: boolean;
  }[];
  mode?: MODE_UI_OPTIONS;
} & ModalProps;

/**
 * Get style sheet based on mode
 * @param mode
 * @returns
 */
const useStyles = createUseStyles((theme: ReturnType<typeof colorsModeUI>) => ({
  modal: {
    backgroundColor: `${theme.MODAL_BACKGROUND_COLOR}!important`,
    color: theme.MODAL_COLOR,
  },
  BACKGROUND_COLOR_1: {
    backgroundColor: `${theme.BACKGROUND_COLOR_1}!important`,
    color: theme.MODAL_COLOR,
  },
}));

/**
 * Ui Modal
 * Display the semantic component Modal window using a mode
 * @param bool open
 * @parm object header: {
 *  icon: string/object => could be the name of an icon or the an icon object,
 *  content: string,
 * }
 * @parm string content
 * @param array buttons [{
 *  key: string,
 *  negative: bool,
 *  primary: bool,
 *  onClick: func,
 *  label: string,
 *  iconName: string,
 *  showLabels: bool,
 * }],
 * @param string mode
 */
export default function UiModal(props: UiModalProps) {
  const {
    header = {},
    content,
    buttons = [],
    mode,
    children,
    ...modalProps
  } = props;
  const classes = useStyles({ theme: colorsModeUI(mode) });

  /* The header icon could be the name of the icon (string) or an object (<UiIcon />).
    By the second case we need the class header-ui-icon-text to add a padding top
    */
  let headerView = (
    <Header
      icon={header.icon}
      content={header.content}
      className={`header-ui-icon-text ${classes.BACKGROUND_COLOR_1}`}
    />
  );
  if (typeof header.icon === 'object') {
    headerView = (
      <headerView.type
        {...headerView.props}
        {...{ className: `header-ui-icon-text ${classes.BACKGROUND_COLOR_1}` }}
      />
    );
  }
  return (
    <Modal className={`ui-modal ${classes.modal}`} {...modalProps}>
      {headerView}
      <Modal.Content>
        {content ? <p>{content}</p> : null}
        {children ? children : null}
      </Modal.Content>
      {buttons.length > 0 ? (
        <Modal.Actions>
          {buttons.map((button) => {
            let uiButton = (
              <UiButton
                onClick={button.onClick}
                label={button.label}
                mode={mode}
              />
            );
            uiButton = (
              <uiButton.type
                {...uiButton.props}
                {...(button.negative ? { negative: button.negative } : {})}
                {...(button.primary ? { primary: button.primary } : {})}
                {...(button.showLabels
                  ? { showLabels: button.showLabels }
                  : {})}
                {...(button.iconName ? { iconName: button.iconName } : {})}
                {...(button.key ? { key: button.key } : {})}
              />
            );
            return uiButton;
          })}
        </Modal.Actions>
      ) : null}
    </Modal>
  );
}
